export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      locations: [
        {
          locationNumber: "1001",
          locationUuid: "locations001",
          deviceSerial: "XJDUERYC896CJS",
          modelNumber: "JS01H",
          modelName: "XXXXBOX",
          profile1: {
            profileOrder: 1,
            body: "xxxxxx",
          },
          status: 1
        },
        {
          locationNumber: "1002",
          locationUuid: "locations002",
          deviceSerial: "9CSAC65CD7CD",
          modelNumber: "JS01K",
          modelName: "Hoam",
          profile1: {
            profileOrder: 1,
            body: "xxxxxx",
          },
          status: 1
        }
      ]
    }
  }
}